export const FEATURE_FLAG = 'boysenberry-signup';

export const OFF_TREATMENT = 'off';
export const ON_TREATMENT = 'on';
export const MIN_SIGNUP_TREATMENT = 'minimal';
export const PREF_QUIZ_TREATMENT = 'prefquiz';
export const PREF_QUIZ_BIWEEKLY_TREATMENT = 'prefquiz_biweekly';
export const FRICTION_REDUCTION = 'friction_reduction';

export const BRANDS = Object.freeze({
    imperfectFoods: 'imperfect-foods',
    misfitsMarket: 'misfits-market',
});

export const MANGO_SIGNUP_HREF = 'https://misfitsmarket.com/sign-up';
export const WHITE_LABEL_SIGNUP_HREF = 'https://imperfectfoods.misfitsmarket.com/sign-up';
